import request from '@/utils/http';
import { SRM } from '../constant/constant.js';
// 通过供应商编码查询仓库信息
export const getPhysicsWarehouseInFo = (params) => {
    return request({
        url: `${SRM}/queryPhysicsWarehouseInFoPage`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 增加弹框，关键字查询仓库信息
export const getAllPhysicsWarehouseInFo = (params) => {
    return request({
        url: `${SRM}/getPhysicsWarehouseByParam`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 增加弹框，确定提交增加仓库信息
export const addWarehouse = (params) => {
    return request({
        url: `${SRM}/updateSupplierWarehouseRelationInfo`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 删除仓库信息
export const deleteWarehouse = (params) => {
    return request({
        url: `${SRM}/deleteSupplierWarehouseRelationInfos`,
        method: 'delete',
        data: params
    });
};
// 新增物理仓保存
export const saveQualification = (params) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouseInsert/qualification`,
        method: 'post',
        data: params
    });
};
// 双击查看仓库信息详情
export const warehouseDetail = (params) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/${params.id}`,
        method: 'get'
    });
};

// 网点编码或网点名称模糊查询
export const querySupplierNetInfos = (params) => {
    return request({
        url: `${SRM}/querySupplierNetInfos`,
        method: 'post',
        data: params
    });
};

// 网点同步
export const syncNetInfoToSupplierNetInfoBySupplier = (params) => {
    return request({
        url: `${SRM}/syncNetInfoToSupplierNetInfoBySupplier`,
        method: 'post',
        data: params
    });
};

// 网点启用停用
export const enableOrDisableSupplierNetInfo = (params) => {
    return request({
        url: `${SRM}/enableOrDisableSupplierNetInfo`,
        method: 'put',
        data: params
    });
};

// 网点信息弹窗查询
export const getSupplierNetInfoById = (id) => {
    return request({
        url: `${SRM}/getSupplierNetInfoById/${id}`,
        method: 'get'
    });
};

// 网点信息弹窗修改
export const supplierNetInfo = (params, id) => {
    return request({
        url: `${SRM}/supplierNetInfo/${id} `,
        method: 'put',
        data: params
    });
};

// 仓库信息-模板下载列表
export const leaseFileTplQuery = data => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/leaseFileTplQuery`,
        method: 'post',
        data,
    });
};

// 仓库信息-模板下载列表
export const leaseFileQuery = params => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/leaseFileQuery/${params.whCode}`,
        method: 'get',
        params,
    });
};

// 仓库信息-上传
export const insertUpdate = data => {
    return request({
        url: `${SRM}/supplierQualificationInfo/insertUpdate`,
        method: 'post',
        data,
    });
};

// 仓库信息- 校验物理仓是否满足合格MIP审批的要求
export const validLeaseEnable = data => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/validLeaseEnable`,
        method: 'post',
        data,
    });
};
